import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TuneIcon from "@mui/icons-material/Tune";
import { type FC } from "react";

import * as Styled from "./ViewButton.styles";

export interface ViewButtonProps {
  active: boolean;
  onClick: () => void;
  controls?: string;
}

export const ViewButton: FC<ViewButtonProps> = ({
  active,
  onClick,
  controls,
}) => (
  <Styled.Button
    active={active}
    aria-expanded={active}
    aria-controls={controls}
    onClick={onClick}
  >
    <TuneIcon sx={{ fontSize: 17 }} />
    View
    {active ? (
      <ExpandLessIcon sx={{ fontSize: 16 }} />
    ) : (
      <ExpandMoreIcon sx={{ fontSize: 16 }} />
    )}
  </Styled.Button>
);
